import { useQuery } from 'react-query';
import { SORT_DIRECTION } from '../../../interfaces/enumerables';
import { ProductInList } from '../../../interfaces/product.interface';
import { GetEntities } from '../../../interfaces/shared.interface';
import { apiRQ } from '../../api';

const getProducts = async (params: {
  page: number;
  orderBy: string;
  order: string;
  search?: string;
}): Promise<GetEntities<ProductInList>> => {
  const resp = await apiRQ.get<GetEntities<ProductInList>>('/products', { params });

  return resp.data;
};

export const useProducts = (page: number, sortBy = 'id', order = SORT_DIRECTION.ASC, search = '') => {
  return useQuery<GetEntities<ProductInList>, Error>(
    ['getProducts', page, sortBy, order, search],
    () => getProducts({ page, orderBy: sortBy, order, search: search }),
    {
      cacheTime: 4000,
      staleTime: 10000,
      refetchOnWindowFocus: false,
    },
  );
};
